import type { IInputTextModelValueType, IInputTextPropsWithoutModelValue } from '@/components';
import { reactive, type Ref } from 'vue';
import { DropdownItemBase } from './DropdownItemBase';

type IDropdownItemTextInputProptions = {
    [K in keyof IInputTextPropsWithoutModelValue]: undefined extends IInputTextPropsWithoutModelValue[K]
        ? IInputTextPropsWithoutModelValue[K] | Ref<Exclude<IInputTextPropsWithoutModelValue[K], undefined>> | undefined
        : IInputTextPropsWithoutModelValue[K] | Ref<IInputTextPropsWithoutModelValue[K]>;
};

export class DropdownItemTextInput extends DropdownItemBase {
    public modelValue: Ref<IInputTextModelValueType>;

    props: IInputTextPropsWithoutModelValue;

    get uniqueLoopKey() {
        return `${this.props.id}-${this.props.label}-${this.props.placeholder}-${this.props.icon}`;
    }

    private abuseBlocker: boolean = false;

    private constructor(
        modelValue: Ref<IInputTextModelValueType>,
        props: IDropdownItemTextInputProptions,
        hideDropDownItem?: Ref<boolean>,
    ) {
        super();
        this.modelValue = modelValue;
        this.hideDropDownItem = hideDropDownItem;
        this.props = reactive(props);
    }

    public static create(
        options: { modelValue: Ref<IInputTextModelValueType> } & IDropdownItemTextInputProptions &
            Pick<DropdownItemBase, 'hideDropDownItem'>,
    ): DropdownItemTextInput {
        const { modelValue, hideDropDownItem, ...props } = options;
        return new DropdownItemTextInput(modelValue, props, hideDropDownItem);
    }
}
